import { buildUrl } from './utils';

const state = {};
const actions = {
  get({ rootState: { token } }, { projectId, q } = {}) {
    const url = buildUrl([{ projects: projectId }, { intents: '' }]);
    return this._vm.$http.get(url, { params: { q }, headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => Promise.resolve(data));
  },
  create({ rootState: { token } }, { projectId, name, text, entities } = {}) {
    const url = buildUrl([{ projects: projectId }, { intents: '' }]);
    return this._vm.$http.post(url, { name, text, entities }, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => Promise.resolve(data));
  },
  update({ rootState: { token } }, { projectId, intentId, name, text, entities } = {}) {
    const url = buildUrl([{ projects: projectId }, { intents: intentId }]);
    return this._vm.$http.put(url, { name, text, entities }, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => Promise.resolve(data));
  },

  remove({ rootState: { token } }, { projectId, intentId }) {
    const url = buildUrl([{ projects: projectId }, { intents: intentId }]);
    return this._vm.$http.delete(url, { headers: { Authorization: `Bearer ${token}` } }).then(({ data }) => Promise.resolve(data));
  }
};
export default {
  namespaced: true,
  state,
  actions
};
